import * as React from 'react';
import { BalanceContainer } from '../Balance';
import { CheckoutContainer } from '../Checkout';
import { ActionButtonsContainer } from '../ActionButtons';
import * as styles from './Summary.desktop.css';
import { VisibleViolationsWarningContainer } from '../VisibleViolationsWarning';
import { N1PublicationBannerContainer } from '../N1PublicationBanner/N1PublicationBanner.container';
import { MLSNPublicationBannerContainer } from '../MLSNPublicationBanner/MLSNPublicationBanner.container';
import { Header2 } from '@cian/ui-kit';
import { useApplicationContext } from '../ApplicationContext';
import { SummaryDesktopServicePickerWidget } from './ServicePickerWidget/SummaryDesktopServicePickerWidget';

export const SummaryDesktop = () => {
  const { config } = useApplicationContext();
  const isServicePickerWidgetEnabled = config.get<boolean>('addFormFrontend.ServicePickerWidget.isEnabled') || false;

  return (
    <div className={styles['summary']}>
      {isServicePickerWidgetEnabled ? (
        <SummaryDesktopServicePickerWidget />
      ) : (
        <>
          <div className={styles['title']}>
            <Header2>Стоимость размещения</Header2>
          </div>
          <N1PublicationBannerContainer />
          <MLSNPublicationBannerContainer />
          <div className={styles['container']}>
            <div>
              <BalanceContainer />
            </div>

            <div className={styles['checkout']}>
              <CheckoutContainer />
              <VisibleViolationsWarningContainer />
              <ActionButtonsContainer />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
